// extracted by mini-css-extract-plugin
module.exports = {"orderByPopup":"OrderByDialog_orderByPopup__2mDJu","title":"OrderByDialog_title__3eeK5"};